// Lib
import gql from 'graphql-tag';

// Types
import { MARBLE_LINK } from '../types';

export const createLink = gql`
  mutation CreateLink($input: [MarbleLinkInput]) {
    createLink(input: $input) {
      ${MARBLE_LINK}
    }
  }
`;

export const updateLink = gql`
  mutation UpdateLink($input: [MarbleLinkInput]) {
    updateLink(input: $input) {
      ${MARBLE_LINK}
    }
  }
`;

export const deleteLink = gql`
  mutation DeleteLink($input: MarbleLinkDeleteInput) {
    deleteLink(input: $input) {
      ${MARBLE_LINK}
    }
  }
`;

export const linkBulkFetchFromScrapedUrl = gql`
  mutation LinkBulkFetchFromScrapedUrl($input: LinkFetchFromScrapeInput) {
    linkBulkFetchFromScrapedUrl(input: $input)
  }
`;
